import {HttpClient, HttpStatusCode} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {ClientUserInfo, User} from 'app/core/user/user.types';
import {map, Observable, of, ReplaySubject, switchMap, tap, throwError} from 'rxjs';
import {HttpService} from "../shared/http.service";

@Injectable({providedIn: 'root'})
export class UserService {
    private _httpClient = inject(HttpClient);
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    private _clientUserInfo: ReplaySubject<ClientUserInfo> = new ReplaySubject<ClientUserInfo>(1);

    constructor(
        private _http: HttpService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter for member user info
     * @param value
     */
    set clientUserInfo(value: ClientUserInfo) {
        this._clientUserInfo.next(value);
    }

    /**
     * Getter for member user info
     */
    get clientUserInfo$(): Observable<ClientUserInfo> {
        return this._clientUserInfo.asObservable();
    }

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User) {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    public getClientUserInfo(): Promise<ClientUserInfo> {
        return this._http.get(`/v1/member-client/info`)
            .pipe(
                switchMap((response) => {
                    if (+response.code === HttpStatusCode.Ok) {

                        console.log("Member Info: ", response.data);

                        this._clientUserInfo.next(response.data as ClientUserInfo);

                        return of(response.data as ClientUserInfo);
                    }

                    if (+response.code === HttpStatusCode.Unauthorized) {
                        return of(null);
                    }

                    return throwError(response.message);
                })
            )
            .toPromise();
    }

    public checkIsPhoneNumberExist(member_id: string, phone_number: string) {
        const formData = new FormData();
        formData.append('member_id', member_id);
        formData.append('phone_number', phone_number);

        return this._http.post(`/v1/member-client/is-phone-number-exist`, formData)
            .pipe(
                switchMap((response) => {
                    if (+response.code === HttpStatusCode.Ok) {
                        return of(response.data);
                    }

                    return throwError(response.message);
                })
            )
            .toPromise();
    }

    /**
     * Update the user
     *
     * @param user
     */
    update(user: User): Observable<any> {
        return this._httpClient.patch<User>('api/common/user', {user}).pipe(
            map((response) => {
                this._user.next(response);
            }),
        );
    }
}
